import { render, staticRenderFns } from "./CartInvoiceAddress.vue?vue&type=template&id=37b474b0"
import script from "./CartInvoiceAddress.vue?vue&type=script&lang=js"
export * from "./CartInvoiceAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports